import { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

import AuctionToBin from "./components/convertListing/AuctionToBin";

import useLocalStorage from "../../hooks/useLocalStorage";

const conversionTypeOptions = [
  {
    label: "Auction to Bin Store",
    value: "AUC_TO_BIN",
  },
];

const ConvertListingPage = () => {
  // Active Tabs:
  // 0 = AUC -> BIN, 1 = SKU -> BIN
  const [activeTab, setActiveTab] = useLocalStorage(
    "convertListingTab",
    "AUC_TO_BIN" // Initial value for the tab index
  );
  const [submitting, setSubmitting] = useState(false);

  // Every time the tab is changed, set the localStorage.
  useEffect(() => {
    setActiveTab(activeTab);
  }, [activeTab]);

  return (
    <>
      <Helmet title="Convert Listing" />
      <h1 className="d-flex justify-content-between mb-3">Convert Listing</h1>
      <Container fluid className="p-0">
        {/* 
        Uncomment this out and add to the conversionTypeOptions to expand
        <Row className="justify-content-center mb-3">
          <Col xl={6}>
            <ListGroup horizontal>
              {conversionTypeOptions.map((conversionOption) => (
                <ListGroup.Item
                  key={conversionOption.value}
                  tag="a"
                  className="text-center"
                  onClick={() => {
                    setActiveTab(conversionOption.value);
                  }}
                  action
                  active={activeTab === conversionOption.value}
                  disabled={submitting}
                >
                  {conversionOption.label}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
        </Row> */}
        <Row className="justify-content-center">
          {activeTab === "AUC_TO_BIN" ? (
            <Col xl={6}>
              <AuctionToBin
                submitting={submitting}
                setSubmitting={setSubmitting}
              />
            </Col>
          ) : null}
        </Row>
      </Container>
    </>
  );
};

export default ConvertListingPage;
